module.exports = __webpack_public_path__ + "img/3-reunions_view.aac5e269.jpg";